
import React from "react";
import "../Chatbox/Chat.css";
import { IoLogoWhatsapp } from "react-icons/io";
import { MdOutlineWifiCalling3 } from "react-icons/md";

const Chat = () => {
  const handleWhatsAppClick = () => {
    const url =
      "https://api.whatsapp.com/send/?phone=447700172170&text=Hello+Click4Flight%21+I%27d+like+to+inquire+about+travel+options.&type=phone_number&app_absent=0";
    window.open(url, "_blank");
  };

  const calladmin = () => {
    window.location.href = "tel:02033557350  ";
  };

  return (
    <>
      {/* Desktop – WhatsApp */}
      <div className="chat-component2 desktop-only" onClick={handleWhatsAppClick}>
        <IoLogoWhatsapp className="icon-chat" />
      </div>

      {/* Mobile – Call */}
      <div className="chat-component2 mobile-only" onClick={calladmin}>
        <span className="call-label">Speak to Expert</span>
        <MdOutlineWifiCalling3 className="icon-chat call-icon" />
      </div>
    </>
  );
};

export default Chat;